export default "__VITE_ASSET__CTbad6vp__"